var s = Object.defineProperty;
var m = (t, e, a) => e in t ? s(t, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[e] = a;
var o = (t, e, a) => m(t, typeof e != "symbol" ? e + "" : e, a);
import { BaseEnvironment as i } from "./main6.js";
class n extends i {
  constructor() {
    super(...arguments);
    /**
     * Webmotors base domain
     *
     */
    o(this, "domain", "hportal.webmotors.com.br");
    /**
     * Local http protocol
     *
     */
    o(this, "protocol", "http");
    /**
     * Enable logging for LOCAL Environment
     *
     */
    o(this, "logging", !0);
    /**
     * Disable sending headers
     *
     */
    o(this, "disabledHeaders", !0);
    /**
     * Webmotors api URL
     *
     */
    o(this, "apiURL", `https://${this.domain}/api`);
    /**
     * Webmotors private api URL
     *
     */
    o(this, "apiPrivateURL", "https://yur5i9svf7-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/hml/api");
    /**
     * Webmotors base URL
     *
     */
    o(this, "baseURL", `https://${this.domain}`);
    /**
     * Cookie domain on LOCAL environment
     *
     */
    o(this, "cookieDomain", [
      this.domain,
      `.${this.domain}`,
      ".webmotors.com.br",
      "localhost"
    ]);
    /**
     * Auth Cookie Name on LOCAL environment
     *
     */
    o(this, "authCookieName", "webmotors.jwt.token.hk");
    /**
     * Access Token Cookie Name on LOCAL environment
     *
     */
    o(this, "accessTokenCookieName", "webmotors.access.token");
    /**
     * Refresh Token Cookie Name on LOCAL environment
     *
     */
    o(this, "refreshTokenCookieName", "webmotors.refresh.token.hk");
    /**
     * Vehicle photo path on LOCAL environment
     *
     */
    o(this, "photoPath", "https://himage.webmotors.com.br");
    /**
     * Webmotors chat api websocket URL
     *
     */
    o(this, "chatApiUrl", "wss://hchat.webmotors.com.br");
    /**
     * Hot deal image path on LOCAL environment
     *
     */
    o(this, "hotDealImage", "https://image.webmotors.com.br/feiroes/imagens/hml/_portal/");
    /**
     * Data Dog Sample Config
     */
    o(this, "traceSampleRate", 0);
    o(this, "sessionSampleRate", 0);
    o(this, "sessionReplaySampleRate", 0);
    /**
     * Seller shield image path
     */
    o(this, "sellerShieldImage", "https://s3.amazonaws.com/webmotors/blindagem-fotos/hml/");
    /**
     * Login route
     *
     */
    o(this, "loginRoute", `https://${this.domain}/login`);
  }
}
export {
  n as LocalEnvironment
};
